export default class BaseAlert extends HTMLElement {
  constructor(
    message = '',
    type = ''
  ) {
    super()

    if (this.innerHTML && !message) {
      // Copy initial contents of <base-alert>
      // if message argument left empty
      this.contents = this.innerHTML
    } else {
      this.contents = message
    }

    // Make sure it's got the alert class applied
    this.classList.add('alert')

    if (type && ![...this.classList].includes(`alert-${type}`)) {
      this.classList.add(`alert-${type}`)
    }

    // Set up message
    this.alertMessage = document.createElement('span')
    this.alertMessage.classList.add('alert-message')
    this.alertMessage.innerHTML = this.contents

    // Set up dismissal button
    this.btn = document.createElement('button')
    this.btn.setAttribute('type', 'button')
    this.btn.classList.add('btn-sm', 'btn-close', 'alert-close')
    this.btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 100 100" aria-hidden="true" class="icon" focusable="false"><path d="M90 20L80 10 50 40 20 10 10 20l30 30-30 30 10 10 30-30 30 30 10-10-30-30z"/></svg>'

    // Clean out parent element and add everything in
    this.innerHTML = ''
    this.append(this.alertMessage)
    this.append(this.btn)

    // Let handleEvent handle the close button
    this.btn.addEventListener('click', this)
  }

  handleEvent(event) {
    this.remove()
  }
}
